import { RootState } from "../../../app/store";

export const submitFeedbackSelector = (state: RootState) => {
    return state.submitFeedback;
}